import Layout from "../components/Layout";
import { TransfersBlotter } from "../components/_Transactions/TransfersBlotter";

const TransferBlotterPage = (props: any) => {
    return (
        <Layout>
            <TransfersBlotter />
        </Layout>
    )
}

export default TransferBlotterPage